export default __webpack_public_path__ + "locales/sr-Cyrl-RS/ChangeUserTypeDialog.json?hash=f0a28c4a355503f5f23676412ab9da36";